webpackJsonp([25],{

/***/ "Jvzq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/video-steps_53c57f0b54b5e9f0e5575d8ed314d829.html";

/***/ }),

/***/ "L1PK":
/***/ (function(module, exports, __webpack_require__) {

var VideoSteps = (function () {
    function VideoSteps() {
    }
    return VideoSteps;
}());
angular.module('animatronApp.videoSteps', []).component('videoSteps', {
    bindings: {
        steps: '<',
        reverse: '<'
    },
    controller: VideoSteps,
    templateUrl: __webpack_require__("Jvzq")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/25-82c0e6a2dceb23823569.min.js